import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { TOKEN_CHECK_INTERVAL } from '@/constants';
const pushToLoginPage = (redirectPath: string | null) => {
  if (!redirectPath?.startsWith('/auth')) {
    localStorage.setItem('okta-post-login-path', encodeURIComponent(redirectPath ?? '/'));
  }
  window.location.replace('/auth/login');
};
export const useTokenValidator = () => {
  const $ = _c(6);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = pathname?.startsWith("/auth") ?? false;
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isAuthPage = t0;
  let t1;
  let t2;
  if ($[2] !== isAuthPage || $[3] !== pathname) {
    t1 = () => {
      let interval;
      if (!isAuthPage) {
        const validateToken = async () => {
          ;
          try {
            const res = await fetch("/api/auth/validate-token");
            const data = await res.json();
            if (!data.valid) {
              await fetch("/api/auth/logout", {
                method: "POST"
              });
              pushToLoginPage(pathname);
            }
          } catch (t3) {
            const error = t3;
            console.error("Token validation error:", error);
            pushToLoginPage(pathname);
          }
        };
        validateToken();
        interval = setInterval(validateToken, TOKEN_CHECK_INTERVAL);
      }
      return () => {
        if (interval) {
          clearInterval(interval);
        }
      };
    };
    t2 = [pathname, isAuthPage];
    $[2] = isAuthPage;
    $[3] = pathname;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
};